import React from 'react';
import _ from 'lodash';

import { FieldComponent } from '@jutro/components';

class SgSelect extends FieldComponent {
    static propTypes = {
        ...FieldComponent.propTypes,
    };

    componentDidMount() {
        const {
            id,
            path,
            onValidate,
            modelVM
        } = this.props;

        if (onValidate) {
            onValidate(_.get(modelVM, path).aspects.valid, id);
        }
    }

    componentDidUpdate(prevData) {
        const {
            id,
            path,
            onValidate,
            value,
            modelVM
        } = this.props;
        const valueChanged = !_.isEqual(value, prevData.value);
        if (onValidate && valueChanged) {
            const isValid = _.get(modelVM, path).aspects.valid;
            onValidate(isValid, id);
        }
    }

    selectValue(event) {
        if (this.props.blockOnBlur && event.type === 'blur') {
            return;
        }
        const code = event.target.value;
        if (code !== undefined && code !== '') {
            _.get(this.props.modelVM, this.props.path).value = code;
        } else {
            _.get(this.props.modelVM, this.props.path).value = undefined;
        }
        if (this.props.onModelChange) {
            this.props.onModelChange(_.get(this.props.modelVM, this.props.path).value, this.props.path);
        } else {
            this.props.updateData(this.props.modelVM);
        }
    }

    renderControl() {
        const renderValues = (values) => {
            return values.map((value) => {
                return (
                    <option key={value.code} value={value.code}>
                        {value.name}
                    </option>
                );
            });
        };

        const renderSections = () => {
            const sections = this.props.values;
            return sections.map((section) => {
                return (
                    <React.Fragment key={section.id}>
                        {section.sectionName && <optgroup label={section.sectionName} />}
                        {renderValues(section.values)}
                    </React.Fragment>
                );
            });
        };

        const getValue = () => {
            return _.get(this.props.modelVM, `${this.props.path}.value.code`)
                || _.get(this.props.modelVM, `${this.props.path}.value`);
        };

        return (
            <div>
                <select
                    onBlur={this.selectValue.bind(this)}
                    onChange={this.selectValue.bind(this)}
                    value={getValue()}
                >
                    {renderSections()}
                </select>
            </div>
        );
    }

    render() {
        return super.render();
    }
}

export default SgSelect;
